<template>

	<div class="w-full">
		<vs-row vs-justify="center">
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12" vs-sm="12" class="text-left px-2">
				<vs-input
				v-model.trim="questionsByPage[index].content"
				class="w-full"
				@blur="validateUrl"
				:label="$t('MODULE.inputLink')" :placeholder="$t('MODULE.inputLink')"/>
			</vs-col>
		</vs-row>

		<vs-row vs-justify="center">
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="6" vs-sm="12" class="text-left">
				<Default :index="index" :label="$t('MODULE.selectModeView')" option="View"></Default>
			</vs-col>
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="6" vs-sm="12" class="text-left">
				<Color :index="index"></Color>
			</vs-col>
		</vs-row>
	</div>

</template>

<script type="text/javascript">
	import Default from '../../componentsToQuestions/DefaultSelect.vue';
	import Color from '../../componentsToQuestions/Color.vue';
	import { mapState } from 'vuex';
	export default {
		props: ['index'],
		components: { Default, Color },
		computed: {
			...mapState('resource',['questionsByPage']),
		},
		methods: {
            /**
             * Valida la estructura del link
             */
			validateUrl(){
					var pattern = new RegExp(/^(https)\:\/\/[a-z0-9\.-]+\.[a-z]{2,4}/gi);
					const _url = this.questionsByPage[this.index].content;

					if(!!!pattern.test(_url)){
						this.questionsByPage[this.index].content = '';
						this.$vs.notify({
				          title:'Danger',
				          text:'No es una url válida.',
				          color:'danger',
				      	  position:'top-right'});
					}else {
						const url = new URL(_url);
						if(!(url.protocol === "https:")){
							this.questionsByPage[this.index].content = '';
							this.$vs.notify({
					          title:'Danger',
					          text:'La url debe contener protocolo de seguridad https.',
					          color:'danger',
					      	  position:'top-right'});
						}
					}
			}
		},
	}
</script>
